import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

const ROLES = [
  { value: 'admin',      label: 'مدير' },
  { value: 'supervisor', label: 'مشرف' },
  { value: 'team',       label: 'فريق' },
];

export default function Users() {
  const { api, user } = useAuth();
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', role: 'team', password: '' });

  const load = () => api('/users').then(setItems).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  const startNew = () => { setEditing(null); setForm({ name: '', email: '', role: 'team', password: '' }); setShowForm(true); };
  const startEdit = (u) => { setEditing(u); setForm({ name: u.name, email: u.email, role: u.role, password: '' }); setShowForm(true); };

  const save = async () => {
    try {
      if (editing) {
        await api(`/users/${editing.id}`, { method: 'PUT', body: JSON.stringify({ name: form.name, email: form.email, role: form.role }) });
        if (form.password) await api(`/users/${editing.id}/reset-password`, { method: 'POST', body: JSON.stringify({ password: form.password }) });
      } else {
        await api('/users', { method: 'POST', body: JSON.stringify(form) });
      }
      setShowForm(false); load();
      toast.success('تم الحفظ');
    } catch (e) { toast.error(e.message); }
  };

  const toggleActive = async (u) => {
    try { await api(`/users/${u.id}`, { method: 'PUT', body: JSON.stringify({ is_active: !u.is_active }) }); load(); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>👤 المستخدمون</h2>
        {user?.role === 'admin' && (<button className="btn btn-primary" onClick={startNew}>+ مستخدم جديد</button>)}
      </div>
      {showForm && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="card-title">{editing ? 'تعديل مستخدم' : 'مستخدم جديد'}</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 12 }}>
            <input className="form-input" placeholder="الاسم" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}/>
            <input className="form-input" placeholder="البريد" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} type="email" dir="ltr"/>
            {user?.role === 'admin' && (
              <select className="form-select" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
            )}
            <input className="form-input" placeholder={editing ? 'كلمة سر جديدة (اختياري)' : 'كلمة المرور'} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} type="password"/>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button className="btn btn-primary" onClick={save}>حفظ</button>
            <button className="btn btn-outline" onClick={() => setShowForm(false)}>إلغاء</button>
          </div>
        </div>
      )}
      <div className="card">
        <table className="table">
          <thead><tr><th>الاسم</th><th>البريد</th><th>الدور</th><th>الحالة</th><th></th></tr></thead>
          <tbody>
            {items.map(u => (
              <tr key={u.id}>
                <td>{u.name}</td>
                <td dir="ltr" style={{ fontSize: 13 }}>{u.email}</td>
                <td>{ROLES.find(r => r.value === u.role)?.label || u.role}</td>
                <td><span className={`badge badge-${u.is_active ? 'completed' : 'revision'}`}>{u.is_active ? 'نشط' : 'معطّل'}</span></td>
                <td style={{ display: 'flex', gap: 4 }}>
                  <button className="btn btn-sm btn-outline" onClick={() => startEdit(u)}>✏️</button>
                  <button className="btn btn-sm btn-outline" onClick={() => toggleActive(u)}>{u.is_active ? '🚫' : '✓'}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
